import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppSideNav, AppTopHeader } from "..";
import { RequireAuth } from "../../../services";
import { useContext, useEffect, useRef, useState } from "react";
import { sendOTP, Sync } from "../../../SyncService";
import { analytics, triggerLogEvent } from "../../../config/firebase";

import { useAuthContext } from "../../../context/AuthContext";
import { initDemo } from "../../../helper/demoHelper";
import { useWalletContext } from "../../../context/WalletContext";
import BusinessLoader from "../BusinessLoader";
import { BASE_URL, EMIONBOARDINGSTATUS, VERIFIED } from "../../../constants";
import withObservables from "@nozbe/with-observables";
import { of } from "rxjs";
import ConfirmationModal from "../Modals/ConfirmationModal";
import RNPVerifyModal from "../Modals/RNPVerifyModal";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";
import { handleApi } from "../../../apis";
import { GET_AUTHORIZED_CATEGORIES, GET_UNAUTHORIZED_CATEGORIES } from "../../../apis/configuration";

const Menu = ({ txns, payments, invoice, stocks, orders, cash_txns }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [I18n] = useContext(LanguageContext);
  const [hasShownLoader, setHasShownLoader] = useState(false);
  const [isSidebarPinned, setIsSidebarPinned] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);
  const [exceedTransactionModal, setExceedTransactionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRNPModal, setShowRNPModal] = useState(false);
  const prevPathnameRef = useRef(null);
  const p = location.pathname.toLowerCase();
  const isCompleteOnboardingPage = p.includes("/completeonboarding");
  const isTransactionFormPage = p.includes("/accounts/transactionform");
  const isContactFormPage = p.includes("/accounts/contactform");
  const isReminderPage = p.includes("/accounts/reminder");
  const isInvoiceBookCreatePage = p.includes("/invoicebook/create");
  const isInvoiceBookEditPage = p.includes("/invoicebook/edit");
  const isSaleBookPage = p.includes("/salebook");
  const isPurchaseBill = p.includes("/purchaseinvoice/create");
  const isExpenseFormPage = p.includes("expense/expenseform");
  const isEditPurchaseBill = p.includes("/purchaseinvoice/edit");
  const isLoadMoney = p.includes("/loadmoney");
  const isShowQR = p.includes("/showqr");
  const isSendMoney = p.includes("/ucash/sendmoney");
  const isAccountLimit = p.includes("/ucash/accountlimit");
  const isEasyload = p.includes("/easyload") && !p.includes("/easyloadtransactions");
  const isBillPayments = p.includes("/billpayments");
  const isVouchers = p.includes("/vouchers");
  const isQuickSaleFormPage = p.includes("quicksale/quicksaleform");
  const isEditProfile = p.includes("profile/edit");
  const isStockBookCreatePage = p.includes("/inventory/create");
  const isStockBookEditPage = p.includes("/inventory/edit");
  const isCreateStockManagement = p.includes("/saddarinventory/createstock");
  const isCreateBusinessForm = p.includes("/createbusinessform");
  const isTransactionSuccessPage = p.includes("/transactionsuccess");
  const isRequestMoney = p.includes("/ucash/requestmoney");
  const isCashBookCashIn = p.includes("/sales/cashbook/cashin");
  const isCashBookCashOut = p.includes("/sales/cashbook/cashout");
  const { setBusiness, setUser, user, pinVerified } = useAuthContext();
  const isDemo = window.location.href.includes("web-demo");
  const isVerifyPinPage = location.pathname === "/VerifyPin";
  const { fetchWalletData, walletDataIsLoading, walletData, EMIVerified } =
    useWalletContext();
  const verified = walletData?.account_info?.verified;
  const isVerifiedAccountForWallet =
    walletData?.account_info?.verified === VERIFIED.VERIFIED;
  // UCash main screen renders wallet onboarding full-screen (no sidebar/header)
  const isWalletOnboardingPage = p.includes("/walletonboarding");

  const isUcashTransactionDetailsPage = p.includes("transactiondetail");

  useEffect(() => {
    // Only show the loader the first time walletDataIsLoading is true
    if (!walletDataIsLoading && hasShownLoader) {
      setHasShownLoader(false);
    }
  }, [walletDataIsLoading, hasShownLoader]);

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("web-demo")) {
      initDemo({ setUser, setBusiness, navigate, location });
    }
  }, []);

  //useEffect For Wallet
  useEffect(() => {
    if (location.pathname?.toLowerCase()?.includes("ucash")) {
      if (!verified && user?.phone_number) {
        setHasShownLoader(true);
        fetchWalletData({ navigate });
      } else if (!isVerifiedAccountForWallet && user?.phone_number)
        navigate("/WalletOnboarding");
    }
  }, [verified, location.pathname, isVerifiedAccountForWallet, user, EMIVerified]);

  useEffect(() => {
    const isUCashRoute = location.pathname?.toLowerCase()?.includes("ucash");
    if (!isUCashRoute || location.pathname?.toLowerCase()?.includes("walletonboarding"))
      return;

    if (user && !user?.phone_number) {
      navigate("/WalletOnboarding", { replace: true });
      return;
    }

    if (!user) return;

    if (EMIVerified) return;

    navigate("/WalletOnboarding", { replace: true });
  }, [location.pathname, walletDataIsLoading, walletData, user, EMIVerified]);

  useEffect(() => {
    const lp = location.pathname.toLowerCase();
    if (
      user &&
      lp !== "/" &&
      lp !== "/signup" &&
      lp !== "/ucash/verifypin" &&
      lp !== "/verifypin" &&
      lp !== "/walletonboarding"
    ) {
      localStorage.setItem("lastVisited", location.pathname);
    }

    if (lp.includes("udhaarbook")) {
      navigate("/Accounts");
    }
    if (location.pathname.split("/").length === 2 && lp.includes("invoicebook"))
      navigate("/Sales/SaleInvoice", { state: { saleMode: "sale_invoice" } });
    if (lp.includes("purchasebill"))
      navigate("/PurchaseOrders", { state: { saleMode: "purchase_bill" } });
    if (
      location.pathname.split("/").length === 2 &&
      lp.includes("purchaseinvoice")
    )
      navigate("/PurchaseOrders", { state: { saleMode: "purchase_bill" } });
  }, [location.pathname, navigate, user]);

  useEffect(() => {
    if (navigator.onLine) {
      const isVerifyPinRoute = location.pathname
        .toLowerCase()
        .includes("verifypin");
      if (user && user?.is_active && user?.phone_number && !isVerifyPinRoute) {
        Sync(user.phone_number, navigate);
        getAuthorizedCategories();
      } else if (!user) {
        getUnauthorizedCategories();
      }
    }
  }, [user]);

  useEffect(() => {
    const url = window.location.href;
    const count = txns + payments + invoice + stocks + orders + cash_txns;
    if (count >= 8 && !user?.phone_number) {
      if (url.includes("web-demo")) {
        // stop OTP
      } else {
        setExceedTransactionModal(true);
      }
    }
  }, [txns, payments, invoice, stocks, user, cash_txns]);

  const isCategoriesCacheFresh = () => {
    const cachedAt = localStorage.getItem("categories_at");
    const ONE_DAY = 24 * 60 * 60 * 1000;
    return !!(cachedAt && Date.now() - Number(cachedAt) < ONE_DAY);
  };

  const cacheCategories = (categories) => {
    if (categories && Object.keys(categories).length) {
      localStorage.setItem("categories", JSON.stringify(categories));
      localStorage.setItem("categories_at", String(Date.now()));
    }
  };

  const getAuthorizedCategories = async () => {
    try {
      if (isCategoriesCacheFresh()) return;
      const response = await handleApi(
        GET_AUTHORIZED_CATEGORIES,
        {},
        undefined,
        navigate,
      );
      cacheCategories(response?.categories || response);
    } catch (error) {
      console.error("Failed to fetch categories", error);
    }
  };

  const getUnauthorizedCategories = async () => {
    try {
      if (isCategoriesCacheFresh()) return;
      const response = await handleApi(
        GET_UNAUTHORIZED_CATEGORIES,
        {},
        undefined,
        navigate,
      );
      cacheCategories(response?.categories || response);
    } catch (error) {
      console.error("Failed to fetch categories", error);
    }
  };

  const sentOTP = async () => {
    try {
      const phone = localStorage.getItem("phone_number");
      if (!phone) return;
      setLoading(true);
      let params = {
        phone_number: phone,
        version: "multi-business",
        onboarding_type: "signup",
      };
      const OTPresponse = await sendOTP(params);
      triggerLogEvent(analytics, "login_exploration");
      setLoading(false);
      setExceedTransactionModal(false);
      navigate("/CompleteOnboarding", {
        state: {
          isCompleteOnboarding: true,
          sendOTPResponse: OTPresponse.data,
        },
      });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.id && typeof window !== "undefined" && window.clarity) {
      window.clarity("set", "userId", user.id);
    }
  }, [user]);

  // Add overflow-y: auto to root for UCash and Dashboard routes
  useEffect(() => {
    const rootElement = document.getElementById("root");
    const isUCashRoute = location.pathname?.toLowerCase()?.includes("ucash");
    const isStockItemReportRoute = location.pathname?.toLowerCase()?.includes(
      "/inventory/itemreport/",
    );
    const isDashboardRoute =
      location.pathname === "/Dashboard" || location.pathname === "/Dashboard/";

    if (rootElement) {
      if (isUCashRoute || isDashboardRoute || isStockItemReportRoute) {
        rootElement.classList.add("root-overflow-auto");
      } else {
        rootElement.classList.remove("root-overflow-auto");
      }
    }

    // Cleanup on unmount
    return () => {
      if (rootElement) {
        rootElement.classList.remove("root-overflow-auto");
      }
    };
  }, [location.pathname]);

  // Capture the pathname before each route change so we can detect navigation away from /VerifyPin.
  // Using cleanup gives us the OLD value at the point the next effect fires.
  useEffect(() => {
    return () => {
      prevPathnameRef.current = location.pathname;
    };
  }, [location.pathname]);

  useEffect(() => {
    const handler = () => setShowRNPModal(true);
    window.addEventListener("rnp-token-expired", handler);
    return () => window.removeEventListener("rnp-token-expired", handler);
  }, []);

  const needsVerification = !!(
    user?.phone_number &&
    !pinVerified &&
    !isDemo &&
    !isVerifyPinPage &&
    EMIVerified &&
    location.pathname?.toLowerCase() !== "/ucash/verifypin"
  );

  // When the user needs to verify their PIN, navigate to /VerifyPin.
  // "verifyPinInStack" is a session flag that marks when /VerifyPin is already in history.
  // Any component redirecting to /VerifyPin checks this flag:
  //   - flag set + came from /VerifyPin → navigate(-1) to reuse the existing entry
  //   - flag not set → navigate with replace and set the flag
  // Flag is cleared only on successful verification.
  useEffect(() => {
    if (needsVerification) {
      const inStack = sessionStorage.getItem("verifyPinInStack") === "1";
      const canGoBack = window.history.state?.idx > 0;
      if (inStack && prevPathnameRef.current === "/VerifyPin" && canGoBack) {
        navigate(-1);
      } else {
        sessionStorage.setItem("verifyPinInStack", "1");
        navigate("/VerifyPin", {
          replace: true,
          state: {
            prevRoute: location.pathname,
            backRoute: prevPathnameRef.current,
          },
        });
      }
    }
  }, [needsVerification, navigate]);

  const isShowSidebar = !(
    isCompleteOnboardingPage ||
    isTransactionFormPage ||
    isContactFormPage ||
    isReminderPage ||
    isInvoiceBookCreatePage ||
    isInvoiceBookEditPage ||
    isSaleBookPage ||
    isPurchaseBill ||
    isExpenseFormPage ||
    isEditPurchaseBill ||
    isLoadMoney ||
    isShowQR ||
    isSendMoney ||
    isAccountLimit ||
    isEasyload ||
    isBillPayments ||
    isVouchers ||
    isQuickSaleFormPage ||
    isStockBookCreatePage ||
    isStockBookEditPage ||
    isEditProfile ||
    isCreateStockManagement ||
    isCreateBusinessForm ||
    isTransactionSuccessPage ||
    isRequestMoney ||
    isVerifyPinPage ||
    isWalletOnboardingPage ||
    isUcashTransactionDetailsPage ||
    isCashBookCashIn ||
    isCashBookCashOut
  );

  // Some routes (e.g. SaleBook) need the layout background styling even if the sidebar UI is hidden.
  const shouldApplySidebarLayout = isShowSidebar || isSaleBookPage;

  const isSidebarOpen = isSidebarPinned || isSidebarHovered;

  if (needsVerification && !showRNPModal) return null;

  return (
    <RequireAuth>
      {isShowSidebar && (
        <>
          <AppTopHeader
            isSidebarPinned={isSidebarPinned}
            onMenuToggle={() =>
              setIsSidebarPinned((prev) => {
                const next = !prev;
                if (!next) {
                  setIsSidebarHovered(false);
                }
                return next;
              })
            }
          />
          <AppSideNav
            isPinned={isSidebarPinned}
            isHovered={isSidebarHovered}
            onHoverChange={setIsSidebarHovered}
            onMenuToggle={() =>
              setIsSidebarPinned((prev) => {
                const next = !prev;
                if (!next) setIsSidebarHovered(false);
                return next;
              })
            }
            disableHoverClose={hasShownLoader || walletDataIsLoading}
          />
        </>
      )}
      <div
        className={`${styles.appLayoutContent} ${shouldApplySidebarLayout ? styles.withSidebar : ""} ${isSaleBookPage ? styles.saleBookLayout : ""}`}
        style={
          isShowSidebar
            ? {
              /* Push content only when pinned (click); when hover, sidebar overlays (content stays at 72px) */
              marginLeft: isSidebarPinned && isSidebarOpen ? 254 : 72,
              transition: "margin-left 0.3s ease-in-out",
            }
            : undefined
        }
      >
        {hasShownLoader ? (
          <BusinessLoader loadBusiness={walletDataIsLoading} />
        ) : (
          <Outlet />
        )}
      </div>
      <ConfirmationModal
        open={exceedTransactionModal}
        onConfirm={sentOTP}
        message={I18n.You_reached_your_limit}
        title={I18n.Youve_reached_the_8_transactions_limit}
        confirmText={`${I18n.verify} ${I18n.phone_number}`}
        cancelText={""}
        id="exeed limit_modal"
        confirmButtonClassName="ubPrimaryButton verifyPhoneNumberButton"
        loading={loading}
        customClassName={styles.reachLimitModal}
      />
      <RNPVerifyModal
        open={showRNPModal}
        onVerified={() => setShowRNPModal(false)}
      />
    </RequireAuth>
  );
};

const enhance = withObservables(["business"], ({ business }) => {
  return {
    payments: business?.payment ? business.payment.observeCount() : of(0),
    invoice: business?.invoice ? business.invoice.observeCount() : of(0),
    orders: business?.orders ? business.orders.observeCount() : of(0),
    txns: business?.txns ? business.txns.observeCount() : of(0),
    cash_txns: business?.cash_txn ? business.cash_txn.observeCount() : of(0),
    stocks: business?.getAllUnarchivedStockItemsCount
      ? business.getAllUnarchivedStockItemsCount()
      : of(0),
  };
});
export default enhance(Menu);
